export { VistaValueProposition } from './VistaValueProposition';
